module.exports = __webpack_public_path__ + "img/conference-2016.1b8432f1.jpg";